module.exports = __webpack_public_path__ + "static/media/invitation.4e3959c4.svg";